module.exports = __webpack_public_path__ + "static/PrintManagement-cce631a268857d3ff8318af2da28ac46.svg";